var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFireOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H18C25.732 0 32 6.26801 32 14V18C32 25.732 25.732 32 18 32H14C6.26801 32 0 25.732 0 18V14Z",
    fill: "#FE980F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6668 17.6667C14.1089 17.6667 14.5328 17.4911 14.8453 17.1785C15.1579 16.866 15.3335 16.442 15.3335 16C15.3335 15.08 15.0002 14.6667 14.6668 14C13.9522 12.5713 14.5175 11.2973 16.0002 10C16.3335 11.6667 17.3335 13.2667 18.6668 14.3333C20.0002 15.4 20.6668 16.6667 20.6668 18C20.6668 18.6128 20.5461 19.2197 20.3116 19.7859C20.0771 20.352 19.7333 20.8665 19.3 21.2998C18.8667 21.7332 18.3522 22.0769 17.786 22.3114C17.2198 22.546 16.613 22.6667 16.0002 22.6667C15.3873 22.6667 14.7805 22.546 14.2143 22.3114C13.6481 22.0769 13.1337 21.7332 12.7003 21.2998C12.267 20.8665 11.9232 20.352 11.6887 19.7859C11.4542 19.2197 11.3335 18.6128 11.3335 18C11.3335 17.2313 11.6222 16.4707 12.0002 16C12.0002 16.442 12.1758 16.866 12.4883 17.1785C12.8009 17.4911 13.2248 17.6667 13.6668 17.6667Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFireOrange);
export default __webpack_public_path__ + "static/media/ic_fire_orange.aad4b3d8f80e20bf41cc2b695b15d1e0.svg";
export { ForwardRef as ReactComponent };